import type { RouteObject } from 'react-router-dom';
import GuestGuard from 'src/auth/GuestGuard';
import { Login } from '../elements';

export const authRoute: RouteObject = {
  path: 'auth',
  children: [
    {
      path: 'login',
      element: (
        <GuestGuard>
          <Login />
        </GuestGuard>
      ),
    },
  ],
};
